import { Condition, Conditions, PfeBaseCondition } from './conditions.model';
import { ConditionAdvanced, OPERATORS } from './rules-evaluator/index';
import { PFE_AND, PfeAndCondition } from './and/index';
import { PFE_OR, PfeOrCondition } from './or/index';
import { PFE_EXPRESSION, PfeExpressionCondition } from './expression/index';

export class PfeConditionsNormalizeUtils {
  /**
   * Normalize the input to make more easy the handle of the service the possible conditions are:
   * // Advanced Conditions
   * {
   *   "operator": "OR",
   *   "conditions": [...]
   * }
   *
   * [
   *   {
   *     "expression": "..."
   *   }
   * ]
   *
   * [
   *   {
   *     "type": "MY_FANCY_CONDITION"
   *   }
   * ]
   *
   * @returns A `PfeBaseCondition[]` mapping the legacy conditions to the new conditions.
   *
   * @param conditions
   */
  public static normalizeConditions(conditions: Conditions): PfeBaseCondition[] {
    if (Array.isArray(conditions)) {
      return (conditions as Condition[]).map((condition) => this.normalizeCondition(condition));
    }
    return [this.normalizeCondition(conditions as ConditionAdvanced)];
  }

  private static normalizeCondition(condition: Condition): PfeBaseCondition {
    // Case 1: New condition, no additional check needed
    if ((condition as PfeBaseCondition)?.type) {
      return condition as PfeBaseCondition;
    }
    // Case 2: ConditionAdvanced, then we just need to transform to either "PFE_AND" or "PFE_OR" conditions.
    else if ((condition as ConditionAdvanced).operator === OPERATORS.AND || (condition as ConditionAdvanced).operator === OPERATORS.OR) {
      const type = (condition as ConditionAdvanced).operator === OPERATORS.AND ? PFE_AND : PFE_OR;
      return {
        type: type,
        conditions: (condition as ConditionAdvanced).conditions.map((cond) => this.normalizeCondition(cond)),
      } as PfeAndCondition | PfeOrCondition;
    }
    // Case 3: Expression condition then we just need to add the type "PFE_EXPRESSION"
    else {
      return {
        type: PFE_EXPRESSION,
        ...condition,
      } as PfeExpressionCondition;
    }
  }
}
